export default "__VITE_ASSET__D0l3HfNq__"